import fileSaver from '../../../../../helpers/download.helper'
import { AxiosService } from './../../../../../services/axios.service'
import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { invoicesConstants } from './invoices.constants'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'

const exportData = (params) => (dispatch) => {
	dispatch({
		type: invoicesConstants.EXPORT_DATA,
	})
	dispatch(SiteCreators.showLoading())

	AxiosService.get(`${AdminReportsService.baseURL}/exportar-faturas`, {
		responseType: 'blob',
		params: params,
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			dispatch(downloadData(data))
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = (downloadData) => async (dispatch) => {
	dispatch({
		type: invoicesConstants.DOWNLOAD_DATA,
	})

	await fileSaver(downloadData, 'faturas.csv')
}

export const invoicesActions = { exportData }
